/**
 * CloudWatch RUM 操作ログ
 *
 * @see https://ok-it.backlog.com/view/CMP-1772#comment-789853467
 */
import { AwsRum } from 'aws-rum-web';
import env from './env';

let rumClient = null;

export function initRum() {
    if (!env.RUM_APPLICATION_ID || env.ENV === 'local') return;
    try {
        const config = {
            sessionSampleRate: 1,
            // 直接 Cloudwatch RUM に送信してしまうと
            // ブラウザの拡張機能の広告ブロック（例：uBlock Origin Lite）などで通信がブロックされることがあるため、
            // Amplify の CloudFront に送り、Cloudwatch RUM にリバースプロキシさせて送信する
            // endpoint: `https://dataplane.rum.${env.RUM_REGION}.amazonaws.com`,
            endpoint: `${window.location.origin}/rum`,
            signing: false, // 署名なし
            telemetries: [], // HTTP/エラー等のテレメトリは無効（画面遷移は SDK コアが自動記録）
            allowCookies: true,
            enableXRay: false,
        };
        rumClient = new AwsRum(env.RUM_APPLICATION_ID, '1.0.0', env.RUM_REGION, config);
    } catch (e) {
        console.warn('CloudWatch RUM init failed:', e);
    }
}

const MAX_FORM_ELEMENTS = 100;
const MAX_CHARS = 100;

function collectFormData() {
    try {
        const inputs = document.querySelectorAll('input, select, textarea');
        const result = [];
        for (let i = 0; i < Math.min(inputs.length, MAX_FORM_ELEMENTS); i++) {
            const el = inputs[i];
            if (el.type === 'password') continue; // パスワードは除外
            if (el.hasAttribute('data-rum-ignore')) continue; // 除外指定要素はスキップ
            let value = '';
            if (el.tagName === 'SELECT') {
                value = el.options[el.selectedIndex]?.text ?? el.value;
            } else if (el.type === 'checkbox' || el.type === 'radio') {
                value = el.checked ? 'true' : 'false';
            } else {
                value = el.value ?? '';
            }
            result.push({
                id: (el.id ?? '').slice(0, MAX_CHARS),
                name: (el.name ?? '').slice(0, MAX_CHARS),
                type: el.type ?? el.tagName.toLowerCase(),
                value: String(value).slice(0, MAX_CHARS),
            });
        }
        return result;
    } catch (e) {
        console.warn('collectFormData failed:', e);
        return [];
    }
}

// ボタンのラベルは text prop → 表示テキスト → アイコンクラス → ボタンclass の順で解決する
export function recordButtonClick(buttonEl, textProp) {
    try {
        const iconEl = buttonEl?.querySelector?.('i, svg, img');
        const iconClass = iconEl ? iconEl.getAttribute('class') || iconEl.getAttribute('alt') || '' : '';
        const btnClass = buttonEl?.getAttribute?.('class') || '';
        const domText = (buttonEl?.innerText || '').trim();
        const label = (textProp != null ? String(textProp) : '') || domText || iconClass || btnClass;

        // 同一 class のボタン内での並び順（1始まり）。同一ページに同じアイコンが複数ある場合の識別用
        const sameKind = Array.from(document.querySelectorAll('button')).filter((b) => b.className === btnClass);
        const buttonIndex = sameKind.indexOf(buttonEl) + 1;

        rumClient?.recordEvent('com.okco.storepricechange.button_click', {
            buttonLabel: label.slice(0, MAX_CHARS),
            buttonClass: btnClass.slice(0, MAX_CHARS),
            iconClass: iconClass.slice(0, MAX_CHARS),
            buttonIndex,
            pathname: window.location.pathname,
            formData: collectFormData(),
        });
    } catch (e) {
        console.warn('recordButtonClick failed:', e);
    }
}
